export default __webpack_public_path__ + "static/media/mobile-screen.3e0b2cff.png";